import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'

import ToastComponent from 'src/components/common/TaostComponent.js'
import TeamPlayerService from 'src/service/TeamPlayerService'
import { useNavigate, useParams } from 'react-router-dom'
import CIcon from '@coreui/icons-react'
import { cilMinus, cilPlus } from '@coreui/icons'
import SquadPickedTable from './SquadPickedTable'
const Table = (props) => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(500)
  const [users, setUsers] = useState({})
  const [pickedPlayer, setPickedPlayer] = useState(props.pickedPlayer)
  const urlParams = useParams()
  const [details, setDetails] = useState([])
  const [fixtureId, setFixtureId] = useState(urlParams.fixtureId)
  const columns = [
    {
      key: 'show_details',
      label: 'Pick',
      _style: { width: '1%' },
      filter: false,
      sorter: false,
    },
    { label: 'Player Name', filter: false, key: 'full_name' },
    { key: 'team_name', filter: true, sorting: false },
  ]
  const toggleDetails = (index) => {
    setLoading(true)
    const position = details.indexOf(index)
    const playerId = index
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)
    TeamPlayerService.addInstantPlayer(playerId, fixtureId, props.teamId).then((res) => {
      if (res.status === 200) {
        toast.dismiss()
        ToastComponent(res.message, 'success')
        setPickedPlayer(res.picked_player)
        setLoading(false)
      }
    })
  }

  const navigate = useNavigate()
  const deletePlayer = (index, fixtureId) => {
    TeamPlayerService.deleteTeamPlayer(index, fixtureId).then((res) => {
      if (res.status === 200) {
        setLoading(false)
        toast.dismiss()
        ToastComponent(res.message, 'success')
        if (props.gameType !== 1) {
          navigate('/manage-scores/team-players/' + fixtureId + '/' + props.teamId)
        }
        if (props.gameType === 1) {
          navigate('/manage-scores/team-players/' + fixtureId)
        }
      }
    })
  }

  const getUsers = useEffect(() => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    TeamPlayerService.getTeamPlayer(
      offset,
      itemsPerPage,
      activePage,
      params,
      urlParams.fixtureId,
      urlParams.teamId,
    ).then((result) => {
      setUsers(result.data)
      setPickedPlayer(result.picked_player)
      const layerIds = result.picked_player.map((l) => l.player_id)
      setDetails(layerIds)

      setLoading(false)
    })
  }, [activePage, columnFilter, columnSorter, itemsPerPage, props, urlParams.fixtureId])
  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1} className={`${props.individualPlayerDisplay}`}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Add Individual Players</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <CSmartTable
                columns={columns}
                columnFilter={{
                  external: true,
                }}
                columnSorter={{
                  external: true,
                }}
                scopedColumns={{
                  show_details: (item, number) => {
                    return (
                      <>
                        <td className="py-2">
                          {details.includes(item.id) && (
                            <CButton
                              color={'danger'}
                              // variant="outline"
                              shape="square"
                              onClick={() => {
                                deletePlayer(item.id, fixtureId)
                              }}
                            >
                              <CIcon icon={cilMinus} />
                            </CButton>
                          )}
                          {!details.includes(item.id) && (
                            <CButton
                              color={'success'}
                              // variant="outline"
                              shape="square"
                              onClick={() => {
                                toggleDetails(item.id)
                              }}
                            >
                              <CIcon icon={cilPlus} />
                            </CButton>
                          )}
                        </td>
                      </>
                    )
                  },
                }}
                items={users.data}
                itemsPerPage={itemsPerPage}
                itemsPerPageSelect={false}
                loading={loading}
                pagination={false}
                paginationProps={{
                  activePage: activePage,
                  pages: Math.ceil(users?.total / itemsPerPage) || 1,
                }}
                tableProps={{
                  hover: true,
                  responsive: true,
                }}
                onActivePageChange={(activePage) => setActivePage(activePage)}
                onColumnFilterChange={(filter) => {
                  setActivePage(1)
                  setColumnFilter(filter)
                }}
                onItemsPerPageChange={(itemsPerPage) => {
                  setActivePage(1)
                  setItemsPerPage(itemsPerPage)
                }}
                onSorterChange={(sorter) => setColumnSorter(sorter)}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>

        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Squad (Picked Players)</strong>
            </CAccordionHeader>
            <CAccordionBody>
              {pickedPlayer && (
                <SquadPickedTable
                  pickedPlayer={pickedPlayer}
                  fixtureId={urlParams.fixtureId}
                  teamId={props.teamId}
                />
              )}
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default Table
